var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProiconsEmoji({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 22.4974C17.8221 22.4974 22.1361 18.1835 22.1361 12.862C22.1361 7.54049 17.8221 3.22656 12.5007 3.22656C7.17916 3.22656 2.86523 7.54049 2.86523 12.862C2.86523 18.1835 7.17916 22.4974 12.5007 22.4974Z",
    stroke: "#545454",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3763 11.5592C10.0954 11.5592 10.6784 10.9763 10.6784 10.2572C10.6784 9.53804 10.0954 8.95508 9.3763 8.95508C8.65718 8.95508 8.07422 9.53804 8.07422 10.2572C8.07422 10.9763 8.65718 11.5592 9.3763 11.5592Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6263 11.5592C16.3454 11.5592 16.9284 10.9763 16.9284 10.2572C16.9284 9.53804 16.3454 8.95508 15.6263 8.95508C14.9072 8.95508 14.3242 9.53804 14.3242 10.2572C14.3242 10.9763 14.9072 11.5592 15.6263 11.5592Z",
    fill: "#545454"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1092 15.2051C15.7435 15.8384 15.2175 16.3644 14.5842 16.7301C13.9508 17.0957 13.2323 17.2882 12.5009 17.2882C11.7695 17.2882 11.0511 17.0957 10.4177 16.7301C9.78428 16.3644 9.25829 15.8384 8.89258 15.2051",
    stroke: "#545454",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProiconsEmoji);
export default __webpack_public_path__ + "static/media/proicons_emoji.c74695500bd0dce9814256a376395f8e.svg";
export { ForwardRef as ReactComponent };